import { AxiosError } from 'axios';
import { uploadAssignment } from 'src/services/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { UploadAssignmentPayload } from './../../models/service';
import { QUERY_KEYS } from 'src/enums';

const useUploadAssignment = () => {
  const client = useQueryClient();

  const { mutate, isLoading } = useMutation<void, AxiosError, UploadAssignmentPayload>(
    ['upload-assignment'],
    (payload: UploadAssignmentPayload) => uploadAssignment(payload),
    {
      onSuccess: () => {
        client.invalidateQueries([QUERY_KEYS.ASSIGNMENT]);
      }
    }
  );

  return {
    mutate,
    isLoading
  };
};

export default useUploadAssignment;
